import { createContext } from "react";

export type SelectionSiteContextObj = {
  selectionSiteGroupId?: number | null;
};

const SelectionSiteContext = createContext<SelectionSiteContextObj>({});

export default SelectionSiteContext;
